import httpClient, { IRequest, IResponse, TRequestHeaders } from '../../../apiService/httpClient';
import { getLanguage } from '../../localization';
import { IGetUserResponse, ILogoutResponse } from './iApiResponse';

const BeMaccaferriIdentityProvider = () => {
    let _baseURL = process.env.IDENTITY_BASE_URL as string;

    const _createRequest = <D>(_pathname: string, _queryString?: string, _data?: D): IRequest => {
        return {
            url: _queryString ? _pathname + '?' + _queryString : _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const _createHeaders = (): TRequestHeaders => {
        return {
            'Accept-Language': getLanguage(),
        };
    };

    const getUserAsync = async (): Promise<IResponse<IGetUserResponse>> => httpClient.getAsync(_createRequest('/IdentityV2/GetUser'), _createHeaders());

    const logoutAsync = async (): Promise<IResponse<ILogoutResponse>> => httpClient.getAsync(_createRequest('/IdentityV2/Logout'), _createHeaders());

    return {
        getUserAsync,
        logoutAsync,
    };
};
export default BeMaccaferriIdentityProvider();
